import { SportsEnum } from 'types/generated/client';
import SportBadge from 'components/SportBadge';

interface Props {
  clubName: string;
  accessSummary: string;
  hasTennis: boolean;
  hasPickleball: boolean;
  hasPadel: boolean;
}

export default function ClubIdentity({
  clubName,
  accessSummary,
  hasTennis,
  hasPickleball,
  hasPadel,
}: Props) {
  const sports = [
    hasTennis && SportsEnum.Tennis,
    hasPickleball && SportsEnum.Pickleball,
    hasPadel && SportsEnum.Padel,
  ].filter(Boolean) as SportsEnum[];

  return (
    <div className="flex flex-col items-center gap-2 text-center">
      <h2 className="typography-product-display-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        {clubName}
      </h2>
      {accessSummary && (
        <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {accessSummary}
        </p>
      )}
      {sports.length > 0 && (
        <div className="mt-1 flex flex-wrap items-center justify-center gap-2">
          {sports.map((sport) => (
            <SportBadge key={sport} sport={sport} size="sm" variant="neutral" />
          ))}
        </div>
      )}
    </div>
  );
}
